import React from 'react'
import styled from 'styled-components'
import tinycolor from 'tinycolor2'
import { FormattedDate } from 'react-intl'
import { Container } from 'reactstrap'

const NewsContainer = styled(Container)`
  align-items: center;
  display: flex;
  margin-bottom: 32px;
`

const DateContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.grayContrast};
  border-color: ${({ theme }) => theme.colors.grayContrast};
  border-style: solid;
  border-width: 6px;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 48px;
  padding: 2rem;
  width: 48px;
`

const MonthContainer = styled.div`
  color: ${({ theme }) => theme.colors.secondary };
  font-weight: bold;
`

const Month = styled.span`
  text-transform: capitalize;
`

const YearContainer = styled.div`
  color: ${({ theme }) => theme.colors.secondary };
  font-size: 1.25rem;
  font-weight: bold;
`

const NewsDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  margin-right: 16px;
`

const NewsTitle = styled.a`
  color: ${({ theme }) => theme.colors.main };
  font-size: 1.35rem;
`

const NewsFullDate = styled.span`
  color: ${({ theme }) => tinycolor(theme.colors.secondary).lighten(25).toString() };
  font-size: 0.90rem;
`

const News = ({ news }) => (
  <NewsContainer>
    <DateContainer>
      <MonthContainer>
        <FormattedDate value={ news.date } month="short">
          {(text) => (
            <Month>
              { text }
            </Month>
          )}
        </FormattedDate>
      </MonthContainer>
      <YearContainer>
        <FormattedDate value={ news.date } year="numeric" />
      </YearContainer>
    </DateContainer>
    <NewsDetails>
      <NewsTitle href={news.link} target="_blank" rel="noopener noreferrer">
        {news.title}
      </NewsTitle>
        <FormattedDate
          value={ news.date }
          weekday="long"
          month="long"
          day="2-digit"
          year="numeric"
          timeZone="UTC"
        >
          {(text) => (
            <NewsFullDate>
              { text }
            </NewsFullDate>
          )}
        </FormattedDate>
    </NewsDetails>
  </NewsContainer>
)

export default News



// WEBPACK FOOTER //
// ./src/components/molecules/News/News.js